import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://urhdxiwuezwnqqupzwkn.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVyaGR4aXd1ZXp3bnFxdXB6d2tuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyMDE0MjUsImV4cCI6MjA1OTc3NzQyNX0.n1gP4ZASMnt7kWj2Q6AkjcbFJmtqN-Irj_XzCRYpWPA'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
